/**
 * Created by youzipi on 18/1/13.
 */
import CouponCode from "./coupon";
import moment from 'moment'
import z from '../utils'
import store from '../store'

class Checkout {

  matchedCouponCodeIds = []
  couponCodeIds = []
  couponCodes = [CouponCode]
  product = {}
  member = 0
  amount = 0
  perPrice = 0
  premium = 0

  // // 活动前的 满减不与优惠叠加
  // get totalPrice() {
  //   // debugger
  //   let curComp = store.state.global.currentCompany
  //   if (!z.inActivityDateRange && curComp && curComp.isRenewals) {
  //     return this.originTotalPrice
  //   }
  //   if (this.activityReducePrice !== 0) {
  //     return this.originTotalPrice - this.activityReducePrice
  //   }
  //   return this.originTotalPrice - this.promotionPrice
  // }
  get totalPrice() {
    // debugger
    let curComp = store.state.global.currentCompany
    console.log('%c[checkout-totalPrice]', 'color: #68E868', this.couponCodes)
    let totalPrice = this.originTotalPrice - this.promotionPrice;
    return totalPrice > 0 ? totalPrice : 0.01
  }

  // 活动  满减金额
  get activityReducePrice() {
    if (z.inReduceActivity(this.product)) {
      return this.amount * this.product.discountPrice
    } else {
      return 0
    }
  }

  // 合计抵扣金额
  get promotionPrice() {
    // 如果商标活动有减价，不再计算优惠券金额
    if (this.activityReducePrice > 0) {
      return this.activityReducePrice;
    }

    // offPriceCouponCodes 包含 指定产品满减券 活动满减券
    let offPriceCouponCodes = this.couponCodes
      .filter(code => code && (code.isOffPrice || code.isActivityOffPrice || code.isCrmReduce))

    console.log('%c[checkout-promotionPrice]', 'color: orangered', offPriceCouponCodes)

    if (!offPriceCouponCodes || offPriceCouponCodes.length === 0) {
      return 0
    }
    let promotionPrice = offPriceCouponCodes.reduce((sum, code) => sum + code.offPrice, 0)

    return promotionPrice
  }

  get originTotalPrice() {
    let _product = this.product
    let member = this.member - _product.minMember || 0
    let _totalPrice = this.amount * _product.unitPrice + this.premium
    return _totalPrice
  }

}


export default Checkout



// WEBPACK FOOTER //
// ./src/domain/checkout.js